import { z } from 'zod';
import { ACTIONS, EXTRA_PERMISSIONS, MODULE_KEYS } from './modules.js';
/** Höchstzahl der Rollen je Mandant (KON-073, KON-058) */
export const MAX_ROLES = 30;
/** Alle Rechte, die sich einer Rolle geben lassen: "<modul>.<aktion>". Das Sternchen für „alles“ hat nur der Inhaber. */
const GRANTABLE = new Set([...MODULE_KEYS.flatMap((m) => ACTIONS.map((a) => `${m}.${a}`)), ...EXTRA_PERMISSIONS.map((e) => e.key)]);
const roleName = z.string().trim().min(2, 'Bezeichnung fehlt').max(60, 'Höchstens 60 Zeichen');
const rolePermissions = z
    .array(z.string())
    .max(GRANTABLE.size)
    .refine((list) => list.every((p) => GRANTABLE.has(p)), 'Unbekanntes Recht')
    .transform((list) => [...new Set(list)].sort());
export const createRoleInput = z.object({ name: roleName, permissions: rolePermissions.default([]) }).strict();
export const updateRoleInput = z
    .object({ name: roleName.optional(), permissions: rolePermissions.optional() })
    .strict()
    .refine((v) => v.name !== undefined || v.permissions !== undefined, 'Keine Änderung angegeben');
//# sourceMappingURL=roles.js.map